/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {Injectable} from '@angular/core';
import {AuthService} from './auth.service';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable} from 'rxjs';
import {RedirectService} from './redirect.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService  {

  constructor(private readonly auth: AuthService,  private readonly redirectService: RedirectService) {}


  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    this.redirectService.next(state.url);
    return this.auth.isAuthenticated();
  }
}
